import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

// constants
import RocketSuccessModal from '../../../components/modals/RocketSuccessModal';

// constants
import routes from '../../../constants/routes';

import formulaKeys from '../../../hooks/formulas/_queryKeys';
import { getCachedFormula } from '../../../hooks/formulas/useFormulaQuery';

// models
import { FormulaDetailModel } from '../../../models/formula.model';

const ApprovedSuccessModal: FC<
    React.PropsWithChildren<{
        text?: string;
        message?: string;
        destination?: string | undefined;
        handleClose: (value: boolean) => void;
    }>
> = ({
    text,
    message = 'is live and will start sending to your customers shortly!',
    destination,
    handleClose,
}) => {
    const history = useHistory();
    const queryClient = useQueryClient();

    const { formulaId } = useParams<{ formulaId: string }>();

    const formula = getCachedFormula(parseInt(formulaId)) as FormulaDetailModel;

    const destinationRoute = destination || routes.formulaLive(formulaId);

    const handleClick = () => {
        queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        history.replace(destinationRoute, history.location.state);
        handleClose(false);
    };

    return (
        <RocketSuccessModal
            text={
                text ??
                `${formula?.name} - ${formula?.message_type.toUpperCase()}`
            }
            handleClick={handleClick}
            message={message}
        />
    );
};

export default ApprovedSuccessModal;
